<template lang="pug">
.section-container.section-home
	section-code-acea(:num="0")

	section-intro(:num="2")
	section-video(:num="3")
	section-who(:num="4")
	section-luciano(:num="5")
	section-features(:num="6")
	//-section-partners(:num="7")

	section-footer-solution

	section.section.border-bottom-section
		.section-content
			.columns.is-centered.is-vcentered
				.column
					.title.is-spaced.has-text-centered(style="margin-bottom: .8rem;")
						| {{ $t('about.title_have_company') }}
					p.subtitle.has-text-centered
						| {{ $t('about.title_have_company2') }}
					p.subtitle.has-text-centered
						router-link.button.is-primary(:to="urlCompany")
							| {{ $t('button.find_how') }}

	modal-comp.modal-video(ref="modalvideo" :title="$t('menu.video')" @close="videoPopupClosed")
		.columns.is-centered.is-vcentered(v-if="videoPopup")
			video(width="854" height="480" controls ref="playervideo")
				source(src="/videos/workout-ita.mp4" type="video/mp4" v-if="itLang")
				source(src="/videos/workout-eng.mp4" type="video/mp4" v-else-if="esLang")
				source(src="/videos/workout-eng.mp4" type="video/mp4" v-else)
				| {{ $t('home.no_video_support') }}
</template>

<script>
import ModalComponent from '../components/ModalComponent.vue'
import SectionIntro from '../components/sections/SectionIntro.vue'
import SectionLuciano from '../components/sections/SectionLuciano.vue'
import SectionFeatures from '../components/sections/SectionFeatures.vue'
import SectionVideo from '../components/sections/SectionVideo.vue'
import SectionWho from '../components/sections/SectionWho.vue'
import SectionPartners from '../components/sections/SectionPartners.vue'

import SectionFooterSolution from '../components/sections/SectionFooterSolution.vue'

//import SectionCodeVodafone from '../components/sections/SectionCodeVodafone.vue'
//import SectionCodeEnel from '../components/sections/SectionCodeEnel.vue'
//import SectionCodeReale from '../components/sections/SectionCodeReale.vue'
import SectionCodeAcea from '../components/sections/SectionCodeAcea.vue'
import SectionCode from '../components/sections/SectionCode.vue'

import { ChevronRightIcon } from 'vue-feather-icons'

export default {
	components: {
		ModalComp: ModalComponent,
		SectionIntro,
		SectionLuciano,
		SectionFeatures,
		SectionVideo,
		SectionWho,
		SectionPartners,
		SectionFooterSolution,
		SectionCode,
		SectionCodeAcea,
		ChevronRightIcon
	},
	data() {
		return {
			videoPopup: false,
		}
	},
	computed: {
		itLang() {
			return this.$t('locale.lang') === 'it'
		},
		esLang() {
			return this.$t('locale.lang') === 'es'
		},
		language() {
			return this.$t('locale.lang')
		},
		urlCompany() {
			return '/' + this.$route.params.language + '/company'
		}
	},
	mounted() {
		this.$meta().setOptions({ title: this.$t("title.home") })
		document.getElementsByTagName("BODY")[0].classList.add('page-header')
	},
	methods: {
		openVideoPopup() {
			this.$refs.modalvideo.open()
			this.videoPopup = true
		},
		videoPopupClosed() {
			this.$refs.playervideo.pause()
		}
	},
	watch: {
		language() {
			if (this.videoPopup) {
				this.$refs.modalvideo.close()
				this.videoPopup = false
			}
		}
	}
}
</script>
